import { createContext, useContext, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);
const TOKEN_KEY = "ez_admin_token";
const EMAIL_KEY = "ez_admin_email";

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [email, setEmail] = useState(() => localStorage.getItem(EMAIL_KEY));

  // Note: request interceptor for Authorization header is registered at module
  // load in ./api.js (see comment there). Keeping it out of a useEffect avoids
  // a race where children's useEffects fire before the parent registers it.

  const login = async (em, pw) => {
    const res = await api.post("/admin/login", { email: em, password: pw });
    localStorage.setItem(TOKEN_KEY, res.data.token);
    localStorage.setItem(EMAIL_KEY, res.data.email);
    setToken(res.data.token);
    setEmail(res.data.email);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
    setToken(null);
    setEmail(null);
  };

  const value = { token, email, login, logout, isAuthed: !!token };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
